import React from "react";

// Sanity wordmark + monogram triangle.
export default function Logo({ size = 38, showWord = true }) {
  const ink = "#1A1A1A";
  const gold = "#B89B5E";
  return (
    <div className="flex items-center gap-3" data-testid="brand-logo">
      <svg
        width={size}
        height={size * 1.12}
        viewBox="0 0 60 70"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-label="Sanity logo"
      >
        <path d="M30 4 L56 60 L4 60 Z" stroke={ink} strokeWidth="2" />
        <path d="M30 18 L48 56 L12 56 Z" stroke={gold} strokeWidth="1.4" />
        <path d="M30 32 L40 52 L20 52 Z" stroke={gold} strokeWidth="1.1" />
      </svg>
      {showWord && (
        <div className="leading-none">
          <div
            className="font-serif tracking-[0.18em] uppercase text-[1.05rem] text-[#1A1A1A]"
            style={{ letterSpacing: "0.22em" }}
          >
            Sanity
          </div>
          <div className="text-[0.55rem] tracking-[0.42em] uppercase mt-1 text-[#9A7E47]">
            Body · Mind · Spirit
          </div>
        </div>
      )}
    </div>
  );
}
